import { render, staticRenderFns } from "./CompanyDynamic.vue?vue&type=template&id=032b79c4&scoped=true"
import script from "./CompanyDynamic.vue?vue&type=script&lang=js"
export * from "./CompanyDynamic.vue?vue&type=script&lang=js"
import style0 from "./CompanyDynamic.vue?vue&type=style&index=0&id=032b79c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032b79c4",
  null
  
)

export default component.exports